module.exports = __webpack_public_path__ + "static/media/DSC_0017.c998f394.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/animals/DSC_0017.jpg
// module id = 545
// module chunks = 0